import React from 'react'
import { BackContainer, BackIcon, Text } from './BackButton.style'

const BackButton = (props: any) => {
	return (
		<BackContainer {...props}>
			<BackIcon />
			<Text>Back</Text>
		</BackContainer>
	)
}

export default BackButton
